<template lang="pug">
.plan-comparison
  .row(style='margin-top: 32px; margin-bottom: 32px')
    .col-12
      .card.card--plan-comparison
        a(
          @c
          aria-controls='planComparison'
          aria-expanded='false'
          data-bs-toggle='collapse'
          href='#planComparison'
          role='button'
        )
          .card-body
            span.text {{ $t('pages.planComparison.comparisonTable') }}
            icon.icon-arrow(name='chevron-down')
        #planComparison.collapse
          .col-12.col-table
            table.table.table-bordered
              tbody
                tr
                  th(style='vertical-align: bottom; padding-bottom: 1rem')
                    .text(style='font-weight: 600; font-size: 1rem') {{ $t('pages.planComparison.features') }}
                  th(:key='index' v-for='(plan, index) in plans')
                    .header-plan
                      .header-plan-title
                        icon(:name='plan.icon')
                        span.text {{ plan.title }}
                      .header-plan-description
                        .text {{ plan.description }}
                      .header-plan-button
                        button.btn(
                          :class='plan.buttonClass'
                          :id='"btn_plan_comparison_" + plan.id.replace(" ", "_").toLowerCase()'
                          @click='$emit("startPlan", plan.title)'
                          type='button'
                        ) {{ plan.buttonText }}
                tr(
                  :class='feature.rowClass || ""'
                  :key='index'
                  v-for='(feature, index) in features'
                )
                  th
                    .text {{ feature.name }}
                  th(
                    :key='i'
                    v-for='(value, i) in feature.values'
                    v-if='!feature.rowClass'
                  )
                    template(v-if='value === "check"')
                      img(src='/img/icons/circle-check.svg')
                    template(v-else)
                      .text {{ value }}
                  th(colspan='4' v-if='feature.rowClass')
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';
import config from '@/config';

export default {
  name: 'PlanComparison',
  components: { Icon },
  data() {
    return {
      plans: [
        {
          title: this.$t('pages.planComparison.basic.title'),
          id: 'basic',
          description: this.$t('pages.planComparison.basic.description'),
          icon: 'leaf',
          buttonClass: 'btn-thin',
          buttonText: this.$t('pages.planComparison.basic.buttonText'),
        },
        {
          title: this.$t('pages.planComparison.essential.title'),
          id: 'essential',
          description: this.$t('pages.planComparison.essential.description'),
          icon: 'briefcase',
          buttonClass: 'btn-thin',
          buttonText: this.$t('pages.planComparison.essential.buttonText'),
        },
        {
          title: this.$t('pages.planComparison.advanced.title'),
          id: 'advanced',
          description: this.$t('pages.planComparison.advanced.description'),
          icon: 'building',
          buttonClass: 'btn-primary',
          buttonText: this.$t('pages.planComparison.advanced.buttonText'),
        },
        {
          title: this.$t('pages.planComparison.corporate.title'),
          id: 'corporate',
          description: this.$t('pages.planComparison.corporate.description'),
          icon: 'rocket',
          buttonClass: 'btn-corporative',
          buttonText: this.$t('pages.planComparison.corporate.buttonText'),
        },
      ],
      features: [
        {
          name: this.$t('pages.planComparison.featuresUsage'),
          rowClass: 'linha-cinza',
        },
        {
          name: this.$t('pages.planComparison.userQuantity'),
          values: [
            this.$t('pages.planComparison.upTo5'),
            this.$t('pages.planComparison.upTo10'),
            this.$t('pages.planComparison.upTo20'),
            this.$t('pages.planComparison.custom'),
          ],
        },
        {
          name: this.$t('pages.planComparison.signerQuantity'),
          values: [
            this.$t('pages.planComparison.unlimited'),
            this.$t('pages.planComparison.unlimited'),
            this.$t('pages.planComparison.unlimited'),
            this.$t('pages.planComparison.unlimited'),
          ],
        },
        {
          name: this.$t('pages.planComparison.documentDivision'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          name: this.$t('pages.planComparison.storage'),
          rowClass: 'linha-cinza',
        },
        {
          name: this.$t('pages.planComparison.storageSpace'),
          values: [
            '500 MB',
            '1 Gb',
            '3 Gb',
            this.$t('pages.planComparison.custom'),
          ],
        },
        {
          name: this.$t('pages.planComparison.originalDocumentStorage'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          name: this.$t('pages.planComparison.createFolders'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          name: this.$t('pages.planComparison.createSubfolders'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          name: this.$t('pages.planComparison.sending'),
          rowClass: 'linha-cinza',
        },
        {
          name: this.$t('pages.planComparison.sendingQuantity'),
          values: [
            '180 por ano',
            '360 por ano',
            '600 por ano',
            this.$t('pages.planComparison.custom'),
          ],
        },
        {
          name: this.$t('pages.planComparison.whatsappNotification'),
          values: ['-', 'check', 'check', 'check'],
        },
        {
          name: this.$t('pages.planComparison.emailSending'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          name: this.$t('pages.planComparison.unsortedSigners'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          name: this.$t('pages.planComparison.sendingReport'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          name: this.$t('pages.planComparison.signatureMethods'),
          rowClass: 'linha-cinza',
        },
        {
          name: this.$t('pages.planComparison.electronicSignature'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          name: this.$t('pages.planComparison.advancedSignature'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          name: this.$t('pages.planComparison.digitalCertificateSignature'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          name: this.$t('pages.planComparison.timestampSignature'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          name: this.$t('pages.planComparison.photoSignature'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          name: this.$t('pages.planComparison.batchSignature'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          name: this.$t('pages.planComparison.presentialSignature'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          name: this.$t('pages.planComparison.signatureCombination'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          name: this.$t('pages.planComparison.initials'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          name: this.$t('pages.planComparison.documentManagement'),
          rowClass: 'linha-cinza',
        },
        {
          name: this.$t('pages.planComparison.documentSharing'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          name: this.$t('pages.planComparison.moveDocument'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          name: this.$t('pages.planComparison.bulkUpload'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          name: this.$t('pages.planComparison.folderManagement'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          name: this.$t('pages.planComparison.saveTemplate'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          name: this.$t('pages.planComparison.compatibility'),
          rowClass: 'linha-cinza',
        },
        {
          name: this.$t('pages.planComparison.osCompatibility'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          name: this.$t('pages.planComparison.mobileSignature'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          name: this.$t('pages.planComparison.browserCompatibility'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          name: this.$t('pages.planComparison.customization'),
          rowClass: 'linha-cinza',
        },
        {
          name: this.$t('pages.planComparison.logoCustomization'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          name: this.$t('pages.planComparison.envelopeCustomization'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          name: this.$t('pages.planComparison.security'),
          rowClass: 'linha-cinza',
        },
        {
          name: this.$t('pages.planComparison.auditReports'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          name: this.$t('pages.planComparison.sslCommunication'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          name: this.$t('pages.planComparison.storagePolicy'),
          values: ['check', 'check', 'check', 'check'],
        },
        {
          name: this.$t('pages.planComparison.integrations'),
          rowClass: 'linha-cinza',
        },
        {
          name: this.$t('pages.planComparison.apiIntegration'),
          values: ['-', '-', 'check', 'check'],
        },
      ],
    };
  },
  created() {
    if (config.locale === 'en') {
      this.removeAdvancedSignatureFeature();
    }
  },
  mounted() {
    const collapseElement = this.$el.querySelector('#planComparison');
    collapseElement.addEventListener('shown.bs.collapse', () => {
      this.equalizeHeaderPlans();
      window.addEventListener('resize', this.equalizeHeaderPlans);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.equalizeHeaderPlans);
  },
  methods: {
    equalizeHeaderPlans() {
      const headerPlans = this.$el.querySelectorAll('.header-plan-description');
      let maxHeight = 0;
      headerPlans.forEach((header) => (header.style.height = ''));

      headerPlans.forEach((header) => {
        const height = header.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
      });
      headerPlans.forEach((header) => {
        header.style.height = `${maxHeight}px`;
      });
    },
    removeAdvancedSignatureFeature() {
      this.features = this.features.filter(
        (feature) =>
          feature.name !== this.$t('pages.planComparison.advancedSignature') &&
          feature.name !==
            this.$t('pages.planComparison.digitalCertificateSignature')
      );
    },
  },
};
</script>
<style lang="stylus" scoped>
tbody
  tr
    border-left: none !important
    border-right: none !important
.btn-corporative
  background-color: #202020
  color: #FFFFFF
</style>
